import { useRef, useContext, useEffect } from 'react' 

import { TelemetryContext } from '../context/TelemetryContext'
import { useRegion } from '../hooks/useRegion' 

import { TASK_EVENTS, REGIONS } from '../constants/telemetryEvents'

import '../css/workspace.scss'

export default function TaskDescription({ task }) {
  const { logTelemetryEvent } = useContext(TelemetryContext)
  
  const containerRef = useRef(null)

  useRegion(REGIONS.TASK_DESCRIPTION, containerRef)

  // Track selection and copy events
  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    let lastSelection = ''

    const handleSelectionChange = () => {
      const selectedText = window.getSelection().toString()
      if (selectedText && selectedText !== lastSelection) {
        lastSelection = selectedText
        logTelemetryEvent(TASK_EVENTS.SELECT, {
          selected_text: selectedText,
          timestamp: Date.now()
        })
      } else if (!selectedText) {
        lastSelection = ''
      }
    }

    const handleCopy = () => {
      const selectedText = window.getSelection().toString()
      if (selectedText) {
        logTelemetryEvent(TASK_EVENTS.COPY, {
          selected_text: selectedText,
          timestamp: Date.now()
        })
      }
    }

    el.addEventListener('mouseup', handleSelectionChange)
    el.addEventListener('keyup', handleSelectionChange)
    el.addEventListener('copy', handleCopy)

    return () => {
      el.removeEventListener('mouseup', handleSelectionChange)
      el.removeEventListener('keyup', handleSelectionChange)
      el.removeEventListener('copy', handleCopy)
    }
  }, [logTelemetryEvent])

  return (
    <div ref={containerRef} className="ws-content-section">
      <h3 className="ws-section-title">Task Description</h3>
      <div className="ws-description-box">{task}</div>
    </div>
  )
}